import { settings, groupingLocationsTextColor } from "../index";
import { getContrastYIQ, getLang } from "./common";
import { injectCss } from "./assets";

export function addFont() {
    if (settings.font) {
        let font = settings.font;
        if (!["Sans-serif", "Sans", "Mono"].includes(settings.font)) {
            let fontName = settings.font.replace(/\s/g, '');
            let fontUrl = `https://sl-fonts.proguscommerce.com/${fontName}.woff`;
            injectCss(`@font-face { font-family: '${settings.font}';font-style: normal;font-weight: 400;src: url(${fontUrl}) format('woff');}`);
        } else {
            switch (settings.font) {
                case "Sans-serif":
                    font = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Ubuntu, Helvetica Neue, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol";
                    break;
                case "Sans":
                    font = '"New York", Iowan Old Style, Apple Garamond, Baskerville, Times New Roman, Droid Serif, Times, Source Serif Pro, serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol';
                    break;
                case "Mono":
                    font = '"SF Mono", Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol';
                    break;
            }
        }
        let style = `#store_locator_425_container * {font-family: ${font}}`;
        style += `::placeholder {font-family: ${font};opacity: 1;}:-ms-input-placeholder {font-family: ${font};}::-ms-input-placeholder {font-family: ${font};}`;
        injectCss(style);
    }
}

export function updateColors() {
    let mainTextColor = "black";
    if (settings.mainColor) {
        mainTextColor = getContrastYIQ(settings.mainColor);
    } else {
        settings.mainColor = "#000";
        mainTextColor = getContrastYIQ(settings.mainColor);
    }
    let css = `.leaflet-menu-close-button:hover {color: ${settings.mainColor} !important;}`;
    css += `.progus-store-locator-store-list-element-active, .progus-store-locator-store-list-element:hover{border-left:3px solid ${settings.mainColor}}`;
    css += `.marker-cluster-small, .marker-cluster-large, .marker-cluster-medium {background-color:${settings.groupingLocationsColor}61} .marker-cluster-small div, .marker-cluster-large div, .marker-cluster-medium div {background-color:${settings.groupingLocationsColor}}`;
    css += `.progus-store-locator-tag-checked {background-color: ${settings.mainColor} !important;color: ${mainTextColor} !important;}`;
    css += `.marker-cluster {color:${groupingLocationsTextColor}}`;
    injectCss(css);
}

export function checkRtlLanguage() {
    let rtlLanguages = ["ar", "arc", "dv", "fa", "ha", "he", "khw", "ks", "ku", "ps", "ur", "yi"];
    if (rtlLanguages.includes(getLang())) {
      let style = "input, .leaflet-popup-content {direction:rtl}";
      style += ".progus-store-locator-content, .progus-store-locator-tags-container, .autoComplete_wrapper > input,ul,li {direction:rtl; text-align:right !important;}";
      style += "#progus-store-locator-store-list-elements {text-align:right}";
      style += ".progus-store-locator-clear-searching-phrase-btn {left:10px;right:0 !important;}";
      style += '.sl-ic-1-chevron-left:before {content: "\\f054" !important;}';
      style += '.sl-ic-1-chevron-right:before {content: "\\f053" !important;}';
      style += '.progus-store-locator-input-clear-btn {right:unset !important;left:24px}';
      injectCss(style);
    }
  }